import * as React from "react";
import Button from "../Button";
import Input from "../Input";
import Select from "../Select";
// import Select from "../Select";

interface Field {
  type?: "text" | "select" | "password"; // Support input and select types
  name: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<any>) => void;
  options?: { label: string; value: string }[]; // For Select fields
}

interface FormProps {
  title: string;
  fields: Field[];
  buttonLabel: string;
  onSubmit: (e: React.FormEvent) => void;
  className?: string;
}

const Form: React.FC<FormProps> = ({
  title,
  fields,
  buttonLabel,
  onSubmit,
  className = "",
}) => {
  return (
    <form
      onSubmit={onSubmit}
      className={`p-6 shadow-lg rounded-lg bg-white ${className}`}
    >
      <h2 className="text-2xl font-semibold mb-4">{title}</h2>
      {fields.map((field, index) => (
        <div key={index} className="mb-4">
          <label className="block mb-1 font-medium">{field.name}</label>
          {field.type === "select" && field.options ? (
            <Select
              name={field.name}
              value={field.value}
              onChange={field.onChange}
              options={field.options}
              placeholder={field.placeholder}
            />
          ) : (
            <Input
              placeholder={field.placeholder}
              name={field.name}
              value={field.value}
              onChange={field.onChange}
            />
          )}
        </div>
      ))}
      <Button label={buttonLabel} type="submit" className="w-full" />
    </form>
  );
};

export default Form;
